(function () {
  var BREAKPOINT = 1200;
  var swiperInst = null;
  var config = {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    centeredSlides: true,
    autoplay: { delay: 3000, disableOnInteraction: false },
    navigation: {
      nextEl: '#topbar-next',
      prevEl: '#topbar-prev',
    },
  };

  function initTopbarSwiper() {
    if (window.innerWidth < BREAKPOINT) {
      if (!swiperInst) {
        swiperInst = new Swiper('#topbar-swiper', config);
      }
    } else {
      if (swiperInst) {
        swiperInst.destroy(true, true);
        swiperInst = null;
      }
    }
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initTopbarSwiper, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTopbarSwiper);
  } else {
    initTopbarSwiper();
  }

  window.addEventListener('resize', onResize);
}());
